import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import router from './router'
import { initDataService } from './services/dataService.js'
import configCacheService from './services/configCacheService.js'
import articleDataCacheService from './services/articleDataCacheService.js'
import CachedImage from './components/CachedImage.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

// 导入Lucide图标组件
import {
    FolderOpen,
    Clock,
    FileText,
    Timer,
    Tag,
    Search,
    X,
    ArrowLeft,
    BookOpen,
    Edit3,
    Eye,
    EyeOff,
    ChevronDown,
    ChevronUp,
    Plus,
    Calendar,
    User,
    AlertTriangle,
    File,
    Trash2,
    CheckCircle,
    RefreshCw,
    Wifi
} from 'lucide-vue-next'

const app = createApp(App)
const pinia = createPinia()

app.use(router)
app.use(pinia)
app.use(Antd)

// 全局配置message
app.config.globalProperties.$message = Antd.message

// 全局注册Lucide图标
app.component('FolderIcon', FolderOpen)
app.component('ClockIcon', Clock)
app.component('FileTextIcon', FileText)
app.component('TimerIcon', Timer)
app.component('TagIcon', Tag)
app.component('SearchIcon', Search)
app.component('XIcon', X)
app.component('ArrowLeftIcon', ArrowLeft)
app.component('BookOpenIcon', BookOpen)
app.component('EditIcon', Edit3)
app.component('EyeIcon', Eye)
app.component('EyeOffIcon', EyeOff)
app.component('ChevronDownIcon', ChevronDown)
app.component('ChevronUpIcon', ChevronUp)
app.component('PlusIcon', Plus)
app.component('CalendarIcon', Calendar)
app.component('UserIcon', User)
app.component('AlertTriangleIcon', AlertTriangle)
app.component('FileIcon', File)
app.component('TrashIcon', Trash2)
app.component('CheckCircleIcon', CheckCircle)
app.component('RefreshCwIcon', RefreshCw)
app.component('WifiIcon', Wifi)

// 注册全局组件
app.component('CachedImage', CachedImage)

// 应用初始化函数
async function initializeApp() {
    console.log('🚀 开始初始化应用...')

    try {
        // 并行初始化服务
        const [dataServiceResult, siteConfig, articleDataPreload] = await Promise.allSettled([
            initDataService(),
            configCacheService.preloadSiteConfig(),
            articleDataCacheService.preloadCommonData()
        ])

        // 处理数据服务初始化结果
        if (dataServiceResult.status === 'fulfilled' && !dataServiceResult.value) {
            console.warn('⚠️ 数据服务初始化失败，将使用降级模式')
        }

        // 处理网站配置结果
        if (siteConfig.status === 'fulfilled') {
            console.log('✅ 网站配置预加载成功')
            // 应用网站配置
            configCacheService.applySiteConfig(siteConfig.value)
        } else {
            console.warn('⚠️ 网站配置预加载失败:', siteConfig.reason)
            // 使用默认配置
            const defaultConfig = configCacheService.getDefaultSiteConfig()
            configCacheService.applySiteConfig(defaultConfig)
        }

        // 处理文章数据预加载结果
        if (articleDataPreload.status === 'fulfilled') {
            console.log('✅ 文章数据预加载成功')
        } else {
            console.warn('⚠️ 文章数据预加载失败:', articleDataPreload.reason)
        }

        console.log('✅ 应用初始化完成')
    } catch (error) {
        console.error('❌ 应用初始化失败:', error)
    }
}

// 初始化应用并挂载
initializeApp().finally(() => {
    app.mount('#app')
}) 